<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';
import { Check } from 'lucide-vue-next';

interface Props {
  step: number;
  title: string;
  description: string;
  isActive?: boolean;
  isCompleted?: boolean;
  class?: HTMLAttributes['class'];
}

const props = withDefaults(defineProps<Props>(), {
  isActive: false,
  isCompleted: false,
});

const emit = defineEmits<{
  click: [step: number];
}>();

const handleClick = () => {
  emit('click', props.step);
};
</script>

<template>
  <div
    :class="cn('tw-flex tw-items-center tw-gap-3 tw-cursor-pointer', props.class)"
    @click="handleClick"
  >
    <div
      :class="[
        'tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-full tw-border tw-text-sm tw-font-semibold tw-transition-all',
        props.isActive
          ? 'tw-bg-white tw-text-secondary-500 tw-border-secondary-500'
          : props.isCompleted
          ? 'tw-bg-secondary tw-text-white tw-border-secondary-500'
          : 'tw-bg-white tw-border-gray-300 tw-text-gray-400',
      ]"
    >
      <Check v-if="props.isCompleted" class="tw-w-4 tw-h-4 tw-text-green-500" />
      <span v-else>{{ props.step }}</span>
    </div>
    <div class="tw-flex tw-flex-col">
      <p
        :class="[
          'tw-text-sm tw-font-medium',
          props.isActive ? 'tw-font-bold tw-text-secondary' : 'tw-font-normal tw-text-gray-400',
        ]"
      >
        {{ props.title }}
      </p>
      <p :class="['tw-text-xs', props.isActive ? 'tw-text-secondary-500' : 'tw-text-gray-400']">
        {{ props.description }}
      </p>
    </div>
  </div>
</template>
